(function () {
  'use strict';

  angular
      .module('tf.retailer')
      .controller('AppCtrl', AppCtrl);

  // @ngInject
  function AppCtrl($scope, $state) {
    var vm = this;

    $scope.$state = $state;
  }

})();
